import { $Dictionary } from 'i18next/typescript/helpers'
import { t, TOptionsBase } from 'i18next'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const translate = (key: any, params?: TOptionsBase & $Dictionary): string => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unnecessary-type-assertion
  return t(key, params) as string
}

export default translate
